export const CustomStyle = {
  paddingLeft: "20px",
  marginLeft: "-26px",
  marginRight: "-25px",
}

export const CustomBreadCrumStyle = {
  paddingLeft: "20px",
  marginLeft: "-26px",
  marginRight: "-25px",
  display: "flex",
}

export const CustomClassName =  "bg-white pt-10"
